import styled, { css } from 'styled-components';

import { screenLg, screenMd, screenSm, screenXlg, screenXs } from 'constants/styles/breakpoints';

import Checkbox from 'components/checkbox';

import { COURSES, TEAM_ACTIVITY, USER_ACTIVITY } from 'constants/reporting';

import TeamSelect from '../../Users/components/InviteUsers/TeamSelect';

export const Filters = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 16px;
    background: white;
    width: 100%;

    ${screenMd} {
      width: auto;
      padding: 20px;
    }
  `,
  BasicView: styled.div<{ isTablet?: boolean }>`
    display: block;
  `,
  AdvancedView: styled.div`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
    ${screenMd} {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(180px, max-content));
      column-gap: 20px;
      row-gap: 10px;
      width: fit-content;
      max-width: 100%;
      justify-content: start;
    }
    ${screenXlg} {
      grid-template-columns: repeat(6, minmax(180px, max-content));
    }
  `,
  LoadingOverlay: styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  `,
  AdvancedViewHeader: styled.div<{ isTablet?: boolean }>`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 15px;
    ${screenMd} {
      margin-top: 0px;
      flex-direction: row;
      align-items: center;
      gap: 30px;
    }
  `,
  TeamFilterContainer: styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: space-between;
    font-size: 14px;
    color: var(--light-gray-darker);
    font-weight: 400;
    ${screenMd} {
      gap: 10px;
      font-size: 15px;
      min-width: 402px;
    }
  `,
  Buttons: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    margin-top: 16px;

    ${screenMd} {
      display: none;
    }
  `,
  MobileButtonsRow: styled.div`
    display: flex;
    gap: 12px;
    width: 100%;
    justify-content: center;

    button {
      flex: 1;
      min-width: 0;
    }
  `,
  MobileSummary: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: var(--light-gray-darker);
    font-size: 12px;
    font-weight: 500;
    text-align: center;

    span {
      display: inline-block;
    }

    ${screenMd} {
      display: none;
    }
  `,
  IdsFilterContainer: styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
    font-size: 14px;
    color: var(--light-gray-darker);
    font-weight: 400;
    ${screenMd} {
      font-size: 15px;
    }
  `,
};

export const AdvanceTitle = styled.div`
  font-family: var(--font-family-base);
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  grid-column: 1/3;
  color: ${({ theme }) => theme.default.colors.fonts.darkGray} !important;
  ${screenMd} {
    font-size: 14px;
    grid-column: 1/6;
    grid-row: 1/2;
  }
`;

export const AdvanceSubtitle = styled.div`
  font-family: var(--font-family-base);
  font-size: 16px;
  margin-top: 10px;
  font-weight: 500;
  color: ${({ theme }) => theme.default.colors.fonts.dark} !important;
  width: 100%;
  ${screenMd} {
    margin-top: 0px;
    margin-bottom: 5px;
    grid-column: 1 / -1;
  }
  ${screenXlg} {
    /* Match fixed 6-column layout semantics on very large screens */
    grid-column: 1 / 7;
  }
`;

export const filterColumnWidth = css`
  width: 100%;
  ${screenMd} {
    width: 180px;
  }
  @media (min-width: 1550px) {
    width: 200px;
  }
`;

export const DateFilter = styled.div<{ isTablet?: boolean; showModalLayout?: boolean }>`
  font-size: 15px;
  line-height: 19px;
  display: flex;
  flex-direction: ${({ showModalLayout }) => (showModalLayout ? 'column' : 'column-reverse')};
  align-items: flex-start;
  justify-content: flex-end;
  label {
    color: var(--light-gray-darker);
    font-weight: 400;
    margin-right: 10px;
  }

  ${screenSm} {
    flex-direction: ${({ showModalLayout }) => (showModalLayout ? 'column' : 'row-reverse')};
  }

  ${({ showModalLayout }) =>
    showModalLayout &&
    `
      display: flex;
      flex-direction: column;
      width: 100%;
  `}
`;

export const TeamsSelector = styled(TeamSelect)``;

export const ClearInput = styled.div<{ showModalLayout?: boolean }>`
  position: absolute;
  div {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: ${({ showModalLayout }) => (showModalLayout ? 46 : 25)}px;
    margin: 2px 0px 0 270px;
    border-radius: 50%;
    transition: background-color 0.3s;
    ${screenXs} {
      margin: 10px 0px 0 210px;
    }
    ${screenSm} {
      margin: 10px 0px 0 57vw;
    }
    ${screenMd} {
      margin: ${({ showModalLayout }) => (showModalLayout ? '0 30px 0 0' : '2px 0px 0 270px')};
    }
  }
`;
export const DateRangeSelectContainer = styled.div<{
  showModalLayout?: boolean;
  isTablet?: boolean;
}>`
  display: grid;
  grid-template-columns: 325px auto;
  align-items: center;
  gap: 10px;

  button {
    height: 43px !important;
  }

  .ant-dropdown-trigger {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: var(--black-darkest, #111a27);
    justify-content: space-between;
  }

  ${({ showModalLayout }) =>
    showModalLayout &&
    `
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    align-items: flex-end;
    gap: 0;
  `}
`;

export const Filter = {
  Container: styled.div<{ endOfRow?: boolean; filtersType?: string }>`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    width: 100%;
    gap: 8px;
    color: ${({ theme }) => theme.default.colors.fonts.dark} !important;
    ${screenMd} {
      gap: 10px;
      ${({ endOfRow, filtersType }) => {
        if (endOfRow) {
          return 'grid-column: 1 / -1;';
        }
      }}
    }
    ${screenXlg} {
      ${({ endOfRow, filtersType }) => {
        if (endOfRow) {
          switch (filtersType) {
            case USER_ACTIVITY:
              return 'grid-column: span 6;';
            case TEAM_ACTIVITY:
              return 'grid-column: span 6;';
            case COURSES:
              return 'grid-column: span 5;';
            default:
              return '';
          }
        }
        return '';
      }}
    }
  `,
  Title: styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    padding-right: 5px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    ${filterColumnWidth}
  `,
  Checkbox: styled(Checkbox)<{ mandatory?: boolean }>`
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: unset !important;
    margin-bottom: 12px;
    font-size: 14px !important;
    gap: 12px;

    &:last-of-type {
      margin-bottom: unset;
    }

    > span:not(.ant-checkbox) {
      width: auto;
      flex: 1;
      white-space: normal !important;
    }

    .ant-checkbox {
      margin-top: 4px;
    }

    ${({ mandatory }) =>
      mandatory &&
      `
      opacity: 0.7;
      pointer-events: none;
    `}

    ${screenMd} {
      margin-bottom: 15px;
      justify-content: space-between;
      align-items: center;
      gap: 10px;

      > span {
        padding: 0px;
        width: unset;
        white-space: pre-line !important;
        > span {
          padding: 0px;
          font-size: 14px !important;
        }
      }

      .ant-checkbox {
        margin-top: 0;
        align-self: flex-start !important;

        min-width: 20px !important;
        width: 20px;
        min-height: 20px !important;
        height: 20px !important;

        .ant-checkbox-input,
        .ant-checkbox-input:after,
        .ant-checkbox-inner {
          min-width: 20px !important;
          width: 20px;
          min-height: 20px !important;
          height: 20px !important;
        }
        .ant-checkbox-input:after {
          background-position-y: 4px !important;
        }
      }
    }
  `,
  Group: styled.div<{ twoColumns?: boolean }>`
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;

    ${screenMd} {
      column-gap: 20px;
      display: ${({ twoColumns }) => (twoColumns ? 'grid' : 'inline-flex')};
      grid-template-columns: ${({ twoColumns }) => (twoColumns ? '1fr 1fr' : '1fr')};
      flex-flow: row;
      align-items: flex-start;
      width: auto;
    }
  `,
  List: styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    flex-flow: column;
    ${filterColumnWidth}
  `,
  Item: styled.div<{ greyed?: boolean }>`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    gap: 5px;
    padding: 5px;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.15s ease-in-out;
    ${({ greyed }) => greyed && `opacity: 50%; pointer-events: none;`}

    .ant-checkbox-wrapper {
      gap: 5px;
    }

    &:hover {
      background-color: var(--grey-lighter);
    }

    svg {
      display: block;
      min-width: 14px;
      flex-shrink: 0;
    }

    ${screenMd} {
      align-items: center;
      width: 100%;

      &:hover {
        box-shadow: inset 0 0 0 1px var(--athens-gray);
      }
    }
  `,
};
